export const mealLockNotice = (mealLabel, status) => {
  if (!status?.is_closed) return null;
  if (status.reason === 'manual') return `${mealLabel} durch Admin geschlossen`;
  if (status.reason === 'sponsored') return `${mealLabel} durch Sponsoring geschlossen`;
  return null;
};
